// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"c39782e8","92":"f7b79c8e","99":"827ac960","215":"53298aa7","337":"737275ee","443":"d959160b","453":"87015e02","479":"c17022a5","531":"b04e98de","952":"d125e4a1"}[chunkId] + ".chunk.js";
};